import React, { useEffect } from 'react';
import Header from '../../../headerone/Main';
import Bredcom from '../../../Bredcom/Main';
import ZoningPermitsDetails from '../../subdepartmentdetails/ZoningPermits';

function ZoningPermits() {
  useEffect(() => {
    document.getElementById('title').innerHTML = 'Zoning and Permits Services || Housing and Community Development';
  }, []);

  return (
    <>
      {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

      <div className="page-wrapper">
        <Bredcom
          subtitle="Housing"
          title="Zoning & Permits Services"
          subtitledown="Department of Housing & Community Development"
        />
        <ZoningPermitsDetails />
      </div>
    </>
  );
}

export default ZoningPermits;
